import React, { Fragment } from 'react';

const VRTourJob = () => {
  return (
    <Fragment>
      <div className="job-overlay">
        <div className="job-post-container">
          <i className="fas fa-times fa-3x job-x"></i>
          <div className="job-desc">
            <div className="link-container">
              <p className="desc-border bold mt-20">Job Description</p>
            </div>
            <div className="desc-body">
              <div className="job-preview">
                <div className="job-desc-info">
                  <ul className="desc-info">
                    <li className="desc-item">Software Engineer</li>
                    <li className="desc-item">Charles Schwab</li>
                    <li className="desc-item">Lone Tree, CO</li>
                  </ul>
                </div>
                <div className="avi-company">
                  <div className="post-avi mx-20"></div>
                </div>
                <div className="apply">
                  <button className="apply-now background-blue">
                    <i className="far fa-file-alt mx-5"></i>Apply
                  </button>
                </div>
              </div>
              <div className="desc-content-container">
                <div className="desc-content">
                  <h6 className="desc-heading">Job Scope</h6>
                  <ul className="scope-items">
                    <li className="scope-item">
                      Applicants
                      <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                      24
                    </li>
                    <li className="scope-item">
                      Work Environment
                      <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                      Agile
                    </li>
                    <li className="scope-item">
                      Job Variation Rating (1-10)
                      <i className="fas fa-long-arrow-alt-right blue mx-5"></i>{' '}
                      8
                    </li>
                    <li className="scope-item">
                      Innovative Employer
                      <i className="fas fa-award mx-5 blue"></i>
                    </li>
                  </ul>
                </div>
                <div className="description">
                  <h6 className="desc-heading">Description</h6>
                  <p className="desc-paragraph">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Aliquid asperiores, rem autem consectetur minus sit, in
                    consequuntur magnam alias, temporibus voluptatum reiciendis
                    omnis ab earum modi laudantium ex velit eaque?Ratione labore
                    voluptate sunt odit, neque illum iste corporis quaerat
                    laudantium voluptates aliquid voluptas minima ducimus nam
                    blanditiis expedita mollitia vero accusamus distinctio!
                    Debitis molestias eos doloremque officiis quibusdam
                    mollitia!
                  </p>
                </div>
                <div className="desc-content">
                  <h6 className="desc-heading">Responsibilities</h6>
                  <ul className="desc-paragraph">
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Troubleshoot complicated, distributed problems in a
                      software system
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Use of HTML, Javascript and CSS for modern browsers such
                      as Chrome, Firefox and IE
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Working and Understanding browser compatibility issues and
                      Responsive web design
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Translation of functional requirements and high-level
                      design of components and modules into a developed and
                      tested, multi-tier solution, including user interface,
                      business logic and database
                    </li>
                  </ul>
                </div>
                <div className="desc-content">
                  <h6 className="desc-heading">Qualifications</h6>
                  <ul className="desc-paragraph">
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Bachelor's degree in Computer Science, or related area or
                      similar industry certification or experience
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Experience with architectural design of large-scale,
                      highly reliable, and highly available internet facing
                      application using best in breed enterprise toolsets like
                      Java, J2EE or Microsoft .NET
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Experience implementing and supporting database
                      persistence strategies in enterprise level database
                      technologies like Oracle, SQL Server, PostGreSQL, or MSQL
                    </li>
                    <li className="resp-item">
                      <i className="fas fa-long-arrow-alt-right blue mr-5"></i>
                      Experience working in or desire to work in an Agile
                      environment (Scrum/XP/Kanban)
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VRTourJob;
